// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__A4s-8","input":"Checkbox_input__kZvcI","checkbox":"Checkbox_checkbox__T2c7K","checkmark":"Checkbox_checkmark__b+zP7"};